import { render, staticRenderFns } from "./BbsDetail.vue?vue&type=template&id=9720b404"
import script from "./BbsDetail.vue?vue&type=script&lang=js"
export * from "./BbsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports